import { RootState } from '@/redux/store'
import { useSelector } from 'react-redux'

export function useReduxState(reducer: keyof RootState) {
  return useSelector((store: RootState) => store[reducer])
}
